const Helper = {
  methods: {
    hasCustomerId(){
      // console.log('hasCustomerId',JSON.parse(this.$store.state.auth).customer_id);
      return JSON.parse(this.$store.state.auth).customer_id ? true : false;
    },
    totalPrice() {
      let total = 0;
      for (let key in this.cart) {
        let item = this.cart[key];
        let price = (item.actual_price) ? item.actual_price : item.item.retail_price;
        total += parseFloat(price) * item.quantity;
      }
      return total;
    },
    shippingCharge() {
      let total = 0;
      let shippingTotal = 0;
      let shipPerOrder = 0;
      this.cart.forEach(function (item, key) {
        if (!item.item.type.includes('Training') && !item.item.type.includes('learning')) {
          if (parseFloat(item.item.ship_per_item) == 0 && parseFloat(item.item.ship_per_order) == 0 && item.item.type.toLowerCase() != 'download') {
            let price = (item.actual_price) ? item.actual_price : item.item.retail_price;
            total += parseFloat(price) * item.quantity;
          } else if (parseFloat(item.item.ship_per_item)) {
            shippingTotal += item.quantity * item.item.ship_per_item;
            if (shipPerOrder < item.item.ship_per_order) {
              shipPerOrder = item.item.ship_per_order;
            }
          }
        }
      });
      shippingTotal += shipPerOrder;
      if (total) {
        if (total.toFixed(2) <= 10) {
          shippingTotal += 2;
        } else if (total.toFixed(2) <= 25) {
          shippingTotal += 3;
        } else if (total.toFixed(2) <= 75) {
          shippingTotal += 5;
        } else if (total.toFixed(2) <= 250) {
          shippingTotal += 7.5;
        } else if (total.toFixed(2) <= 500) {
          shippingTotal += 10;
        }
      }
      return shippingTotal.toFixed(2);
    },
    showNav() {
      $("#nav-open-basket").click(function () {
        document.getElementById("main-nav").style.width = "300px";
        document.getElementById("wrapper").style.display = "block";
      });
      $('#nav-open-course').click(function(){
        document.getElementById("main-nav").style.width = "300px";
        document.getElementById("wrapper").style.display ="block";
        document.getElementById("body").style.overflowX="visible";
        document.getElementById("body").style.position="fixed";
     });
    },
  },
  computed: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
      ) {
        return true;
      } else {
        return false;
      }
    },
    totalPrices() {
      let total = 0;
      for (let key in this.cart) {
        let item = this.cart[key];
        let price = (item.actual_price) ? item.actual_price : item.item.retail_price;
        total += parseFloat(price) * item.quantity;
      }
      return total;
    },
    shippingCharges() {
      let total = 0;
      let shippingTotal = 0;
      let shipPerOrder = 0;
      this.cart.forEach(function (item, key) {
        if (!item.item.type.includes('Training') && !item.item.type.includes('learning')) {

          if (parseFloat(item.item.ship_per_item) == 0 && parseFloat(item.item.ship_per_order) == 0 && item.item.type.toLowerCase() != 'download') {
            let price = (item.actual_price) ? item.actual_price : item.item.retail_price;
            total += parseFloat(price) * item.quantity;

          } else if (parseFloat(item.item.ship_per_item)) {
            shippingTotal += item.quantity * item.item.ship_per_item;
            if (shipPerOrder < item.item.ship_per_order) {
              shipPerOrder = item.item.ship_per_order;
            }
          }
        }
      });
      shippingTotal += shipPerOrder;
      if (total) {
        if (total.toFixed(2) <= 10) {
          shippingTotal += 2;
        } else if (total.toFixed(2) <= 25) {
          shippingTotal += 3;
        } else if (total.toFixed(2) <= 75) {
          shippingTotal += 5;
        } else if (total.toFixed(2) <= 250) {
          shippingTotal += 7.5;
        } else if (total.toFixed(2) <= 500) {
          shippingTotal += 10;
        }
      }
      return shippingTotal.toFixed(2);
    },
    subtotalPrice() {
      let total = this.totalPrice();
      return total.toFixed(2);
    },
    Vat() {
      let totalTax = 0;
      for (let key in this.cart) {
        let item = this.cart[key];
        let price = (item.actual_price) ? item.actual_price : item.item.retail_price;
        totalTax += parseFloat((parseFloat(price) * item.quantity) / 100) * item.item.tax;
      }
      return (totalTax + ((this.shippingCharge() / 100) * 20)).toFixed(2);
    },
    getCartTotal() {
      localStorage.setItem("totalPrice", (parseFloat(this.subtotalPrice) + parseFloat(this.shippingCharge()) + parseFloat(this.Vat)).toFixed(2));
      return (parseFloat(this.subtotalPrice) + parseFloat(this.shippingCharge()) + parseFloat(this.Vat)).toFixed(2);
    }
  }
}
export default Helper